export default __webpack_public_path__ + "static/media/blue.5d2ce1af.svg";